import { z } from 'zod';

/**
 * O que chega do assistente. Validado com Zod antes de qualquer cálculo:
 * nada que vem do navegador é confiável.
 */

export const TipoCasa = z.enum(['terrea', 'sobrado', 'grande', 'apartamento', 'sitio', 'praia']);
export type TipoCasa = z.infer<typeof TipoCasa>;

export const Ambiente = z.enum([
  'sala',
  'cozinha',
  'corredor',
  'quartoCasal',
  'outrosQuartos',
  'escritorio',
  'garagem',
  'lavanderia',
]);
export type Ambiente = z.infer<typeof Ambiente>;

export const Preocupacao = z.enum(['viagem', 'noite', 'dormir', 'bairro', 'alarmeAntigo', 'mensalidade']);
export type Preocupacao = z.infer<typeof Preocupacao>;

export const DistanciaAreaExterna = z.enum(['ate15', 'de15a30', 'acima30']);
export type DistanciaAreaExterna = z.infer<typeof DistanciaAreaExterna>;

export const AreaExterna = z.object({
  nome: z.string().trim().min(1).max(60),
  distancia: DistanciaAreaExterna,
  aberturas: z.number().int().min(0).max(32),
  presencas: z.number().int().min(0).max(32),
});
export type AreaExterna = z.infer<typeof AreaExterna>;

export const Escolhas = z.object({
  tipoCasa: TipoCasa,
  temPet: z.boolean(),
  /** Cliente pediu sensor de presença sem fio mesmo sem pet. */
  preferirSemFio: z.boolean().default(false),
  portas: z.number().int().min(0).max(100),
  janelas: z.number().int().min(0).max(100),
  ambientes: z.array(Ambiente).max(Ambiente.options.length),
  areaExterna: AreaExterna.nullable().default(null),
  controles: z.number().int().min(0).max(100),
  preocupacoes: z.array(Preocupacao).default([]),
});
export type Escolhas = z.infer<typeof Escolhas>;
export type EscolhasEntrada = z.input<typeof Escolhas>;
